import React from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextButton from 'LuxKit/Button/TextButton'
import Pill from 'LuxKit/Pill'
import Heading from 'LuxKit/Typography/Heading'
import TextLink from 'LuxKit/TextLink'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import useJoinLuxPlusFreePreview from 'luxPlus/hooks/useJoinLuxPlusFreePreview'

function LuxPlusFreePreviewCtaSection() {
  const {
    onPendingJoinFreePreview,
    hasInviteExpiryDate,
    formattedExpiryDate,
    invitePillExpiryCopy,
  } = useJoinLuxPlusFreePreview()

  return <Pane paletteType="default" data-testid="lux-plus-free-preview-cta-section">
    <PaneBody size="md">
      <VerticalSpacer gap={16}>
        <VerticalSpacer gap={8} >
          <Pill
            endIcon={null}
            kind="primary"
            startIcon={null}
            variant="success"
          >
            {invitePillExpiryCopy}
          </Pill>
          <Heading variant="heading3">{LUXURY_PLUS.FREE_PREVIEW_DURATION}-day Free Preview</Heading>
          <BodyText variant="medium" colour="primary-dark">
            Discover hidden offers, view member pricing and find out what life is like in our VIP Travel Club. {hasInviteExpiryDate && `This exclusive invite is only valid until ${formattedExpiryDate}.`} <b>No credit card required!</b>
          </BodyText>
        </VerticalSpacer>
        <TextButton kind="primary" fit="full-width" onClick={onPendingJoinFreePreview}>Start Free Preview now</TextButton>
        <BodyText variant="small">
          To book an offer with LuxPlus+ benefits during your Free Preview you will be prompted to become a member.
          {' '}<TextLink weight="regular" to={`/${LUXURY_PLUS_PATHS.TERMS_AND_CONDITIONS_PAGE}`}>T&Cs apply.</TextLink>
        </BodyText>
      </VerticalSpacer>
    </PaneBody>
  </Pane>
}

export default LuxPlusFreePreviewCtaSection
